var React = require('react');

function ArrowDownHollow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.5 5.981l2.398-2.74H2.102L4.5 5.98zm-4.602-3.74h9.204L4.5 7.5-.102 2.24z","fill":"currentColor","fillRule":"nonzero"}));
}

ArrowDownHollow.defaultProps = {"width":"9","height":"9","viewBox":"0 0 9 9"};

module.exports = ArrowDownHollow;

ArrowDownHollow.default = ArrowDownHollow;
